import Collection from '@/lib/business/models/Collection';
import Group from '@/lib/business/models/groups/Group';
import DeploymentIndex from '@/lib/deployments/models/DeploymentIndex';
import QuickLink from '../models/QuickLink';

const endpointNameFactory = (entity) => {
  if (entity instanceof Collection) {
    return 'collection';
  }

  if (entity instanceof Group) {
    return 'group';
  }

  if (entity instanceof DeploymentIndex) {
    return 'deploymentIndex';
  }

  console.error('Could not find customization entity type for', entity);
  return null;
};

const endpointFactory = (entity) => {
  const endpointName = endpointNameFactory(entity);

  if (endpointName) {
    const url = `v2/${endpointName}/quicklinks`;
    return url;
  }

  return null;
};

class QucikLinksClient {
  /**
   * @type {AxiosInstance}
   */
  http = null;

  constructor(http) {
    this.http = http;
  }

  async getQuickLinks(entity) {
    if (entity) {
      console.log('Getting quick links for ', entity);
      const endPoint = endpointFactory(entity);
      console.log('Getting quick links for ', entity, 'endpoint ', endPoint);
      if (endPoint) {
        const url = `${endPoint}/${entity.id}`;
        console.log('Getting quick links for ', entity, 'url ', url);
        const { data } = await this.http.get(url);
        const quickLinks = QuickLink.fromObject(data);
        entity.setQuickLinks(quickLinks);
      }
    }
  }

  async getQuickLinksList(entitiesList) {
    const ids = entitiesList.map((item) => item.id);
    const url = endpointFactory(entitiesList[0]);

    if (url) {
      const { data } = await this.http.post(url, ids);
      const quickLinks = QuickLink.fromObjects(data);
      entitiesList.map((entity, index) => entity.setQuickLinks(quickLinks[index]));
    }
  }

  async saveQuickLinks(entity) {
    const endPoint = endpointFactory(entity);
    const url = `${endPoint}/${entity.id}`;
    const { data } = await this.http.post(url, entity?.quickLinks);
    const quickLinks = QuickLink.fromObject(data);
    entity.setQuickLinks(quickLinks);
  }
}

export default QucikLinksClient;
